import { useRef, useEffect } from 'react';

export default function useAutofocus<T extends HTMLElement = HTMLElement>(
  focus = true,
) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (ref.current && focus) {
      ref.current.focus();
    }
  }, [ref, focus]);

  return ref;
}
